/* Opaque toast surface: the standard Alert tint is translucent, which reads poorly floating over content. */
.toast[data-severity] {
  --toast-accent: var(--tuna-feedback-success);
  min-width: 288px;
  max-width: 480px;
  padding: 12px var(--tuna-spacing-2);
  border-radius: var(--tuna-shape-radius-sm);
  border: 1px solid color-mix(in oklch, var(--toast-accent) 40%, transparent);
  border-left: 4px solid var(--toast-accent);
  background-color: var(--tuna-palette-background-paper);
  background-image: linear-gradient(
    color-mix(in oklch, var(--toast-accent) 10%, transparent),
    color-mix(in oklch, var(--toast-accent) 10%, transparent)
  );
  box-shadow: var(--tuna-shadow-4);
}

.toast[data-severity='error'] {
  --toast-accent: var(--tuna-feedback-error);
}

.toast[data-severity='warning'] {
  --toast-accent: var(--tuna-feedback-warning);
}

.toast[data-severity='info'] {
  --toast-accent: var(--tuna-feedback-info);
}

/* GH #2795 §3: a comment toast is a glance, two lines at most; the full comment is one click away */
.commentMessage {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}
